const waitPromise = (time: number) => new Promise((resolve) => setTimeout(resolve, time ?? 0))
export const immediatePromise = () => waitPromise(0)

export default waitPromise
